import {
  MOBILE_BREAKPOINT,
  TABLET_BREAKPOINT,
} from 'src/js/modules/breakpoint-editing/constants/breakpoints';

// Line heights (in em) for the standard font sizes.
const LINE_HEIGHT = {
  12: 1.66,
  14: 1.71,
  16: 1.75,
  18: 1.77,
  20: 1.6,
  24: 1.5,
  28: 1.57,
  32: 1.37,
  36: 1.44,
  40: 1.4,
  44: 1.36,
  48: 1.33,
  56: 1.46,
  64: 1.25,
};

// Min line heights (in em) for the standard font sizes.
const MIN_LINE_HEIGHT = {
  12: 1.66,
  14: 1.71,
  16: 1.75,
  18: 1.77,
  20: 1.6,
  24: 1.54,
  28: 1.54,
  32: 1.56,
  36: 1.57,
  40: 1.37,
  44: 1.44,
  48: 1.47,
  56: 1.4,
  64: 1.33,
};

const getLineHeightByFontSize = (fontSize) => LINE_HEIGHT[fontSize] ?? 6.7504 / fontSize + 1.2415;

const getMinLineHeightByFontSize = (fontSize) => MIN_LINE_HEIGHT[fontSize] ?? 1.5;

const getLineHeightEm = (fontSize, breakpoint) => {
  if (breakpoint === MOBILE_BREAKPOINT) {
    return getMinLineHeightByFontSize(fontSize);
  }

  if (breakpoint === TABLET_BREAKPOINT) {
    const minLineHeightEm = getMinLineHeightByFontSize(fontSize);
    return minLineHeightEm + (getLineHeightByFontSize(fontSize) - minLineHeightEm) / 1.333;
  }

  return getLineHeightByFontSize(fontSize);
};

export default getLineHeightEm;
